import React from "react";
import PremiumResourcePage, { resourceStatus } from "../../../Components/Dashboard/PremiumResourcePage";

const Users = ({ navigation }) => (
  <PremiumResourcePage
    navigation={navigation}
    title="Users & Roles"
    subtitle="Manage team members, roles, permissions, and workspace access."
    fetchEndpoint="/fetchSubUserProfile"
    deleteEndpoint=""
    columns={[
      { key: "serial", label: "Serial No." },
      { key: "name", label: "Name" },
      { key: "role", label: "Role", render: (row) => resourceStatus(row.role || "Active") },
      { key: "email", label: "Email" },
      { key: "contact", label: "Phone" },
      { key: "state", label: "State" },
    ]}
  />
);

export default Users;
